import { FilterFieldDataType } from "@ukam/core/filters/types/filter-field-data-type.type";
import { FilterFieldOperator } from "@ukam/core/filters/types/filter-field-operator.type";
import { FilterFieldItemParams, filterFieldItemsToParams } from "@ukam/core/filters/params/filter-field-item.params";
import { FilterField } from "@ukam/core/filters/models/filter-field";

export interface FilterFieldParams {
  id?: string | null;
  key?: string | null;
  name?: string | null;
  label?: string | null;
  type?: string | null;
  operator?: string | null;
  expression?: string | null;
  value?: string | null;
  values?: string[] | null;
  start?: string | null;
  end?: string | null;
  display?: string | null;
  items?: FilterFieldItemParams[] | null;
  fields?: FilterFieldParams[] | null;
  selected?: boolean | null;
  showItems?: boolean | null;
  sourceType?: string | null;
  source?: string | null;
}

export function filterFieldToParams(field: FilterField): FilterFieldParams {
  return {
    id: field.id ,
    key: field.key ,
    name: field.name ,
    label: field.label ,
    type: field.type ,
    operator: field.operator ,
    expression: field.expression ,
    value: field.value ,
    values: field.values ,
    start: field.start ,
    end: field.end ,
    display: field.display ,
    items: filterFieldItemsToParams(field.items) ?? [],
    fields: filterFieldsToListParams(field.fields) ?? [],
    selected: field.selected ,
    showItems: field.showItems ,
    sourceType: field.sourceType ,
    source: field.source ,
  };
}

export function filterFieldsToListParams(fields: FilterField[] | null | undefined): FilterFieldParams[] {
  return fields ? fields.map(field => filterFieldToParams(field)) : [];
}
